module.exports = __webpack_public_path__ + "static/uk-flag-d58dbe3fb53f7310876836fdd29d7af6.png";